import { render, staticRenderFns } from "./DetailQuoteBreadcrumb.vue?vue&type=template&id=0b73c4c0&scoped=true&lang=html&"
import script from "./DetailQuoteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DetailQuoteBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuoteBreadcrumb.vue?vue&type=style&index=0&id=0b73c4c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73c4c0",
  null
  
)

export default component.exports